"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlumbingMaterialType = void 0;
var PlumbingMaterialType;
(function (PlumbingMaterialType) {
    PlumbingMaterialType[PlumbingMaterialType["Unknown"] = 1] = "Unknown";
    PlumbingMaterialType[PlumbingMaterialType["Lead"] = 2] = "Lead";
    PlumbingMaterialType[PlumbingMaterialType["Galvanized Steel"] = 4] = "Galvanized Steel";
    PlumbingMaterialType[PlumbingMaterialType["Cast Iron"] = 8] = "Cast Iron";
    PlumbingMaterialType[PlumbingMaterialType["Copper"] = 16] = "Copper";
    PlumbingMaterialType[PlumbingMaterialType["Brass"] = 32] = "Brass";
    PlumbingMaterialType[PlumbingMaterialType["Pvc"] = 64] = "Pvc";
    PlumbingMaterialType[PlumbingMaterialType["Steel"] = 128] = "Steel";
    PlumbingMaterialType[PlumbingMaterialType["Stainless Steel"] = 256] = "Stainless Steel";
    PlumbingMaterialType[PlumbingMaterialType["Other"] = 512] = "Other";
    PlumbingMaterialType[PlumbingMaterialType["Plastic"] = 1024] = "Plastic";
    PlumbingMaterialType[PlumbingMaterialType["Vinyl"] = 2048] = "Vinyl";
    PlumbingMaterialType[PlumbingMaterialType["Rubber"] = 4096] = "Rubber";
    PlumbingMaterialType[PlumbingMaterialType["Bronze"] = 8192] = "Bronze";
    PlumbingMaterialType[PlumbingMaterialType["Solder"] = 16384] = "Solder";
})(PlumbingMaterialType = exports.PlumbingMaterialType || (exports.PlumbingMaterialType = {}));
//# sourceMappingURL=PlumbingMaterialType.js.map